import React from 'react';
import { Alert, Typography } from '@/components/common';

interface Props {
	showNote?: boolean;
}

export const HeaderNote: React.FC<Props> = ({ showNote = true }) => {
	return (
		<>
			<Typography type="semibold-18" className="text-left">
				ACCEPTED AND AGREED TO:
			</Typography>
			{showNote && (
				<Alert
					icon={<></>}
					type="info"
					className="!bg-[#3957F41A] !bg-opacity-0 !p-2 !rounded-lg"
					text={
						<Typography type="regular-14" className="text-left !text-[#2D41F5]">
							<span className="font-semibold">Note:</span> Scroll to the end of
							the document before signing. Please review carefully.
						</Typography>
					}
				/>
			)}
		</>
	);
};
